module.exports = __webpack_public_path__ + "media/assets/images/flags/do-9444f44e5f7b4d697583d350979438bd.svg";